import { useTranslation } from 'react-i18next'
import { Box, Link, Text } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'
import { Checkbox } from '../../../ui/checkbox'
import OrderLocationCard from './OrderLocationCard'
import UnitRow from '../../Units/UnitRow'


const CARPOOL_TERMS_URL = 'https://carpoollogistics.com/terms-conditions/'

export default function OrderReviewStep({
  origin,
  destination,
  quoteDetails,
  originLocationType,
  destinationLocationType,
  vehicles = [],
  gatePasses = {},
  termsAcceptedAt,
  onTermsAcceptedChange,
}) {
  const { t } = useTranslation()
  const isAccepted = !!termsAcceptedAt

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <OrderLocationCard
        label={t('From')}
        values={origin}
        quoteLocation={quoteDetails?.origin}
        locationType={originLocationType}
        accentColor={colors.yellow}
        notesLabel={t('Pickup Instructions')}
      />
      <OrderLocationCard
        label={t('To')}
        values={destination}
        quoteLocation={quoteDetails?.destination}
        locationType={destinationLocationType}
        accentColor="#4A90D9"
        notesLabel={t('Delivery Instructions')}
      />

      {vehicles.length > 0 && (
        <Box display="flex" flexDirection="column" gap={2}>
          <Text fontSize="sm" fontWeight="semibold" color={colors.green}>
            {t('Vehicles')} ({vehicles.length})
          </Text>
          <Box display="flex" flexDirection="column" gap={2}>
            {vehicles.map((vehicle) => {
              const gatePass = gatePasses?.[vehicle.vin]
              const unit = {
                id: vehicle.vin,
                attributes: {
                  year: vehicle.year,
                  make: vehicle.make,
                  model: vehicle.model,
                  vin: vehicle.vin,
                },
              }
              return (
                <Box
                  key={unit.id}
                  borderRadius="md"
                  border="1px solid"
                  borderColor={gatePass ? colors.green : colors.grey700}
                  overflow="hidden"
                >
                  <UnitRow
                    unit={unit}
                    trailing={
                      gatePass && (
                        <Text fontSize="xs" color={colors.green} fontWeight="semibold">
                          {t('Gate Pass Attached')}
                        </Text>
                      )
                    }
                  />
                </Box>
              )
            })}
          </Box>
        </Box>
      )}

      <Box
        p={3}
        borderRadius="md"
        border="1px solid"
        borderColor={isAccepted ? colors.green : colors.grey700}
        bg={colors.grey900}
      >
        <Checkbox
          checked={isAccepted}
          onCheckedChange={({ checked }) => {
            onTermsAcceptedChange?.(checked ? new Date().toISOString() : null)
          }}
          css={{
            '& [data-part="control"][data-state=checked]': {
              bg: colors.green,
              borderColor: colors.green,
            },
          }}
        >
          <Text fontSize="sm" color={colors.grey100}>
            {t('I accept the')}{' '}
            <Link
              href={CARPOOL_TERMS_URL}
              target="_blank"
              rel="noopener noreferrer"
              color={colors.green}
              textDecoration="underline"
              onClick={(event) => event.stopPropagation()}
            >
              {t('Carpool Logistics Terms and Conditions')}
            </Link>
          </Text>
        </Checkbox>
      </Box>

      <Text fontSize="xs" color={colors.grey300} textAlign="center">
        {t('Confirm to place your order.')}
      </Text>
    </Box>
  )
}
